import { Box, BoxProps, alpha, styled } from '@mui/material';

interface BorderContainerProps extends BoxProps {
  dark?: boolean;
}

/**
 * Standard styled box container with border
 * @param {boolean | undefined} dark Optionally render border for dark background as stronger contrasting color.
 * @returns {JSX.Element}
 */
const BorderContainer = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== 'dark'
})<BorderContainerProps>(({ theme, dark }) => ({
  boxSizing: 'border-box',
  backgroundColor: 'transparent',
  border: `1px solid ${alpha(theme.palette.teal ? (dark ? theme.palette.teal.main : theme.palette.teal.dark) : theme.palette.primary.main, 0.5)}`,
  borderRadius: 24,
  padding: '2% 3%'
}));

export default BorderContainer;
